import React from 'react';
import PropTypes from 'prop-types';
import Lottie from 'react-lottie';

import wfGeometricLoop_001 from './Lotties/geometric-loop-001.json';

export default function Loop(props) {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    renderer: 'svg',
    animationData: props.lottieFile,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid meet',
    },
  };

  return (
    <Lottie isClickToPauseDisabled options={props.options || defaultOptions} />
  );
}

Loop.defaultProps = {
  lottieFile: wfGeometricLoop_001,
};

Loop.propTypes = {
  options: PropTypes.object,
  lottieFile: PropTypes.object,
};
